import { FC, useMemo, useRef, useState } from "react";
// 组件
import { ProSpin } from "../../../antd";
import BaseContext from '../../context/LayoutContext';
import IconFont from "../../../IconFont";
import MenuList from "./subpage/menuList";
import TabsRoute from '../../../TabsRoute';
// 方法
import classNames from 'classnames';
import { useNavigate, Outlet } from 'react-router-dom';
import useGlobal from "../../hooks/useGlobal";
// 常量
import { DEFAULT_PROJECT_ICON } from "../../../constants/constant";
import defatleLogo from '../../../accest/images/yunbao.png';
import { BasePageLayoutProps } from "../../interface";
import './style.less';

const BasePageLayout: FC<BasePageLayoutProps> = (props) => {
  const {
    maxCachePage, menu: outMenu, changePasswordApi, getUserInfoApi, getDictApi, logoutApi,
  } = props;
  // 是否显示菜单
  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  // 菜单数据
  const [modeChildrenMenu, setModeChildrenMenu] = useState([]);
  // 当前点击模块
  const currentClickModule = useRef<string>();
  // 鼠标当前进过模块
  const currentMouseModule = useRef<string>();
  const navigate = useNavigate();
  const {
    global,
    dispatch,
    userInfo,
    tenant,
    menu,
    app,
    enumData,
    configData,
    routeTabs,
    routes,
    authority,
    fullPages,
    menuHelp,
    serviceConfig,
    watermarkConfig,
  } = useGlobal(
    outMenu,
    changePasswordApi,
    getUserInfoApi,
    getDictApi,
    logoutApi,
    navigate,
  );
  // 点击菜单
  const handleClickModule = (item: any) => {
    if (item.resourceId === currentClickModule.current) {
      setMenuVisible(!menuVisible);
    } else {
      setMenuVisible(true);
    }
    currentClickModule.current = item.resourceId;
    setModeChildrenMenu(item.children);
  };
  // 鼠标经过菜单
  const handleMouseOver = (item: any) => {
    if (item.resourceId === currentMouseModule.current) return;
    if (menuVisible) {
      setModeChildrenMenu(item.children);
    }
    currentMouseModule.current = item.resourceId;
  };
  /** 左侧类型 */
  const tgLeftClasses = useMemo(() => {
    return classNames('tg-left', {
      [`tg-left-${global.skinType}`]: global.skinType,
    });
  }, [global.skinType]);
  /** 左侧菜单类名 */
  const tgLeftMenuClasses = useMemo(() => {
    return classNames('tg-left-menu', {
      [`tg-left-menu-${global.skinType}`]: global.skinType,
    });
  }, [global.skinType]);

  return (
    <BaseContext.Provider
      value={{
        global,
        dispatch,
        userInfo,
        tenant,
        menu,
        app,
        enumData,
        configData,
        routeTabs,
        routes,
        authority,
        fullPages,
        menuHelp,
        serviceConfig,
        watermarkConfig,
      }}
    >
      <div className='tg-wrapper'>
        <div className={tgLeftClasses}>
          <div
            className={`logo logo-${global.skinType}`}
          >
            <img src={defatleLogo} />
          </div>
          <ul className={tgLeftMenuClasses}>
            {Array.isArray(menu) &&
              menu.map((item: any) => {
                const isActive: boolean = menuVisible && item.resourceId === currentMouseModule.current
                const itemClasses = classNames('tg-left-menu-item', {
                  [`tg-left-menu-item-${global.skinType}`]: global.skinType,
                  active: isActive,
                });
                return (
                  <li
                    className={itemClasses}
                    onClick={() => handleClickModule(item)}
                    onMouseOver={() => handleMouseOver(item)}
                    key={item.path}
                  >
                    <span className="tg-left-menu-item-icon">
                      <IconFont type={item.icon || DEFAULT_PROJECT_ICON} size={24} color="white" active={isActive} />
                    </span>
                    <span className="yb-line-ellipsis" title={item.name}>
                      {item.name}
                    </span>
                  </li>
                );
              })}
          </ul>
          <MenuList
            menuData={modeChildrenMenu}
            visible={menuVisible}
            onCancel={() => setMenuVisible(false)}
          />
        </div>
        <div
          className='tg-right'
        >
          {
            global.isUserInfo ? (
              <TabsRoute
                maxCachePage={maxCachePage}
              >
                <Outlet
                  context={{
                    global,
                    dispatch,
                    userInfo,
                    tenant,
                    menu,
                    app,
                    enumData,
                    configData,
                    routeTabs,
                    routes,
                    authority,
                    fullPages,
                    menuHelp,
                    serviceConfig,
                    watermarkConfig,
                  }}
                />
              </TabsRoute>
            ) : (
              <div className="flex-center-center" style={{ width: '100%', height: '100%', }}>
                <ProSpin />
              </div>
            )
          }
        </div>
      </div>
    </BaseContext.Provider>
  );
};


export default BasePageLayout;
